module.exports = __webpack_public_path__ + "img/62.c6d9a736.jpg";